import { CSSProperties } from "react"
import { Transform } from "@dnd-kit/utilities"

export const CARD_MARGIN = 2
export const CARD_BORDER_RADIUS = 6
export const CARD_COMPACT_MAX_HEIGHT = 45
export const RESIZE_HANDLE_HEIGHT = 8
export const COLOR_STRIP_WIDTH = 8

export const ELLIPSIS_TEXT_STYLE: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  lineHeight: 1.2,
}

export type CardContainerStyleParams = {
  top: number
  height: number
  widthPercent: number
  leftPercent: number
  isCompact: boolean
  isDragging: boolean
  isResizing: boolean
  transform: Transform | null
}

export const getCardContainerStyle = ({
  top,
  height,
  widthPercent,
  leftPercent,
  isCompact,
  isDragging,
  isResizing,
  transform,
}: CardContainerStyleParams): CSSProperties => ({
  position: 'absolute',
  top: top + CARD_MARGIN,
  left: `calc(${leftPercent}% + ${CARD_MARGIN}px)`,
  width: `calc(${widthPercent}% - ${CARD_MARGIN * 2}px)`,
  height: height - CARD_MARGIN * 2,
  display: 'flex',
  flexDirection: isCompact ? 'row' : 'column',
  alignItems: isCompact ? 'center' : undefined,
  justifyContent: isCompact ? 'space-between' : undefined,
  gap: isCompact ? 4 : 1,
  padding: isCompact ? '2px 6px' : '3px 6px',
  borderRadius: CARD_BORDER_RADIUS,
  cursor: isResizing ? 'ns-resize' : 'pointer',
  overflow: 'hidden',
  boxSizing: 'border-box',
  zIndex: isDragging || isResizing ? 100 : 1,
  transform: !isResizing && transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
})

export type CardOuterStyleParams = {
  top: number
  height: number
  widthPercent: number
  leftPercent: number
  isDragging: boolean
  isResizing: boolean
  transform: Transform | null
}

export const getCardOuterStyle = ({
  top,
  height,
  widthPercent,
  leftPercent,
  isDragging,
  isResizing,
  transform,
}: CardOuterStyleParams): CSSProperties => ({
  position: 'absolute',
  top: top + CARD_MARGIN,
  left: `calc(${leftPercent}% + ${CARD_MARGIN}px)`,
  width: `calc(${widthPercent}% - ${CARD_MARGIN * 2}px)`,
  height: height - CARD_MARGIN * 2,
  borderRadius: CARD_BORDER_RADIUS,
  cursor: isResizing ? 'ns-resize' : 'pointer',
  overflow: 'hidden',
  boxSizing: 'border-box',
  zIndex: isDragging || isResizing ? 100 : 1,
  transform: !isResizing && transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
})

export const getCardInnerStyle = ({ isCompact }: { isCompact: boolean }): CSSProperties => ({
  position: 'absolute',
  top: 1,
  bottom: 1,
  left: COLOR_STRIP_WIDTH,
  right: 1,
  display: 'flex',
  flexDirection: isCompact ? 'row' : 'column',
  alignItems: isCompact ? 'center' : undefined,
  justifyContent: isCompact ? 'space-between' : undefined,
  gap: isCompact ? 4 : 1,
  padding: isCompact ? '2px 6px' : '3px 6px',
  backgroundColor: '#ffffff',
  borderRadius: CARD_BORDER_RADIUS,
  overflow: 'hidden',
  boxSizing: 'border-box',
})
